import { ConversationTopic } from "common/types/common.type";

export const TOPIC_OPTIONS: Array<{
  value: ConversationTopic;
  label: string;
  symbol: string;
  description: string;
}> = [
  {
    value: "qatar-lobbying",
    label: "האדרת קטאר",
    symbol: "🇶🇦",
    description: "מסרים שמקדמים את קטאר, תדמיתה או האינטרסים שלה.",
  },
  {
    value: "egypt",
    label: "הכפשת מצרים",
    symbol: "🇪🇬",
    description: "מסרים נגד מצרים (המתווכת המתחרה לקטאר) ודרדור יחסיה עם ישראל",
  },
  {
    value: "war-narrative",
    label: "עסקת החטופים ומסמך הבילד",
    symbol: "🎗️",
    description: "עיצוב השיח על עסקת החטופים, המלחמה והדלפת המסמך לבילד.",
  },
  {
    value: "domestic-politics",
    label: "פוליטיקה",
    symbol: "🏛️",
    description: "הדלפות קבינט והכפשת יריבים פוליטיים.",
  },
];
